import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUseCasePrompt } from "models/IUseCasePrompt";

interface IUseCasePromptsState {
  value: IUseCasePrompt[];
  isLoading: boolean;
}

const initialState: IUseCasePromptsState = {
  value: [],
  isLoading: true,
};

export const useCasePromptsSlice = createSlice({
  name: "useCasePrompts",
  initialState,
  reducers: {
    setUseCasePromptsLoading: (state, action: PayloadAction<boolean>): void => {
      state.isLoading = action.payload;
    },
    setUseCasePrompts: (
      state,
      action: PayloadAction<IUseCasePrompt[]>,
    ): void => {
      state.value = action.payload;
      state.isLoading = false;
    },
    addUseCasePrompt: (state, action: PayloadAction<IUseCasePrompt>): void => {
      state.value.push(action.payload);
    },
    updateUseCasePromptInSlice: (
      state,
      action: PayloadAction<IUseCasePrompt>,
    ): void => {
      const index = state.value.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeUseCasePrompt: (state, action: PayloadAction<string>): void => {
      state.value = state.value.filter((p) => p.id !== action.payload);
    },
  },
});

export const {
  setUseCasePromptsLoading,
  setUseCasePrompts,
  addUseCasePrompt,
  updateUseCasePromptInSlice,
  removeUseCasePrompt,
} = useCasePromptsSlice.actions;

export default useCasePromptsSlice.reducer;
